import React from 'react'

export const IconWindStatus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M55 40c4.565 0 8-3.435 8-8 0-4.565-3.435-9-8-9 0-11.414-9.586-20-21-20-10.102 0-19.2 6.423-21 16h-2C5.292 19 1 24.292 1 30s4.292 10 10 10M27 58a5 5 0 105-5H2"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M40 42a5 5 0 115 5H4"
      />
    </svg>
  );
}

export const IconWindNorth = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M44 32c0-6.628-12-25-12-25S20 25.372 20 32s5.373 12 12 12 12-5.372 12-12z"
      />
    </svg>
  );
}

export const IconWindSouth = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M20 32c0 6.628 12 25 12 25s12-18.372 12-25-5.373-12-12-12-12 5.372-12 12z"
      />
    </svg>
  );
}

export const IconWindEast = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M32 44c6.628 0 25-12 25-12S38.628 20 32 20s-12 5.373-12 12 5.372 12 12 12z"
      />
    </svg>
  );
}

export const IconWindWest = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M62.998999999999995 31.999 A31 31 0 0 1 31.999 62.998999999999995 A31 31 0 0 1 0.9989999999999988 31.999 A31 31 0 0 1 62.998999999999995 31.999 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M35.998999999999995 31.999 A4 4 0 0 1 31.999 35.998999999999995 A4 4 0 0 1 27.999 31.999 A4 4 0 0 1 35.998999999999995 31.999 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M31.999 19.999c-6.628 0-25 12-25 12s18.372 12 25 12 12-5.373 12-12-5.372-12-12-12z"
      />
    </svg>
  );
}

export const IconWindNorthEast = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M40.485 40.484C45.172 35.798 49 15 49 15s-20.799 3.827-25.485 8.514c-4.687 4.688-4.686 12.285 0 16.971 4.685 4.686 12.284 4.687 16.97-.001z"
      />
    </svg>
  );
}

export const IconWindSouthEast = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 31.999 A31 31 0 0 1 32 62.998999999999995 A31 31 0 0 1 1 31.999 A31 31 0 0 1 63 31.999 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 31.999 A4 4 0 0 1 32 35.998999999999995 A4 4 0 0 1 28 31.999 A4 4 0 0 1 36 31.999 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M23.515 40.484c4.687 4.687 25.484 8.515 25.484 8.515S45.172 28.2 40.485 23.514c-4.688-4.687-12.285-4.686-16.971 0-4.686 4.685-4.687 12.284.001 16.97z"
      />
    </svg>
  );
}

export const IconWindNorthWest = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M40.484 23.514C35.798 18.828 15 15 15 15s3.827 20.799 8.514 25.484c4.688 4.688 12.285 4.686 16.971 0 4.686-4.685 4.687-12.283-.001-16.97z"
      />
    </svg>
  );
}

export const IconWindSouthWest = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 32 A31 31 0 0 1 32 63 A31 31 0 0 1 1 32 A31 31 0 0 1 63 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 32 A4 4 0 0 1 32 36 A4 4 0 0 1 28 32 A4 4 0 0 1 36 32 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M23.515 23.515C18.828 28.201 15 48.999 15 48.999s20.799-3.827 25.485-8.514c4.687-4.688 4.686-12.285 0-16.971-4.685-4.686-12.284-4.687-16.97.001z"
      />
    </svg>
  );
}


